import { MembershipIcon } from "apps/portal/src/components/atoms/icons/MembershipIcon";
import { useTranslation } from "react-i18next";

import { CTAWidget } from "./CTAWidget";

export const CTAMembership = () => {
  const { t } = useTranslation();
  return (
    <CTAWidget
      title={t(
        "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileGetMembership.title",
      )}
      subtitle={t(
        "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileGetMembership.subTitle",
      )}
      buttonText={t(
        "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileGetMembership.button",
      )}
      icon={
        <MembershipIcon
          className="absolute -right-7 top-0 z-10 block size-[7.75rem]"
          pathClassName="stroke-secondary-25"
        />
      }
    />
  );
};
